import AdresseAdresse2 from '@/generated/controls/adresse/AdresseAdresse2.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: AdresseAdresse2
})
